import {
  PlacementWarningDialog,
  type PlacementWarningDialogProps,
} from '@/components/app/placement/placement-warning-dialog'

/** Mirrors `TextToImageWarningDialog` (same Cancel/Replace pattern, confirmed for ClikArt per
 *  WMPCM-11014). */
export function ClikArtTextToImageWarningDialog(props: PlacementWarningDialogProps) {
  return (
    <PlacementWarningDialog
      {...props}
      tone="destructive"
      title="Replace text with ClikArt?"
      message="Your text will be erased and replaced with this ClikArt."
      continueLabel="Replace"
    />
  )
}
